module.exports = __webpack_public_path__ + "files/9b8a1e67916b86b663807a8fd784e553.svg";